module.exports = __webpack_public_path__ + "img/10no-seven.6e06b83b.jpg";